/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Social-media platform this link points to.
 */
export type SocialMediaType = (typeof SocialMediaType)[keyof typeof SocialMediaType];

export const SocialMediaType = {
  instagram: "instagram",
  facebook: "facebook",
  tiktok: "tiktok",
  youtube: "youtube",
  linkedin: "linkedin",
  discord: "discord",
  twitch: "twitch",
} as const;
